import { ComponentStore } from '@ngrx/component-store';import { tapResponse } from '@ngrx/operators';

import { Injectable } from "@angular/core";
import { switchMap } from "rxjs/operators";
import { TreeSelectModel } from "@hrra/common-models";
import { SpecializationService } from "../services/specialization.service";

export interface SpecializationTreeSelectState {
    loading: boolean;
    specializationTree: TreeSelectModel<string>[];
    overlayVisible: boolean;
}

export const initialState: SpecializationTreeSelectState = {
    loading: false,
    specializationTree: [],
    overlayVisible: false
}

export interface TreeInputUpdateCommand
{
    newValues: string[];
    existingValues: string[];
    additionalCheckRequired: boolean;
}

@Injectable()
export class SpecializationTreeSelectStore extends ComponentStore<SpecializationTreeSelectState> {

    constructor(private specializationService: SpecializationService) {
        super(initialState)
    }

    loading$ = this.select(s => s.loading);
    specializationTree$ = this.select(s => s.specializationTree);
    overlayVisible$ = this.select(s => s.overlayVisible);

    //updates

    readonly updateLoading = this.updater((state, loading: boolean) => {
        return {
            ...state,
            loading: loading
        }
    });

    readonly updateOverlayVisible = this.updater((state, overlayVisible: boolean) => {
        return {
            ... state,
            overlayVisible: overlayVisible
        }
    });

    readonly updateSpecializationTree = this.updater((state, specializationTree: TreeSelectModel<string>[]) => {

        return {
            ...state,
            specializationTree: specializationTree,
            loading: false,
        }
    });

    readonly loadSpecializationTree = this.effect((parentId$) => {
        return parentId$.pipe(
            switchMap(() => {
                this.updateLoading(true);
                return this.specializationService.getTreeSelectSpecializations().pipe(
                    tapResponse({
                        next: (response) => {
                            this.updateSpecializationTree(response.data);
                        },
                        error: error => {
                            this.updateLoading(false)
                        }
                    })
                );
            })
        );
    });

}